<template>
  <div class="row my-children-2">
    <slot name="top"/>
    <template v-for="configoption in group.konfigurationsmoeglichkeiten">
      <SortenInput
          v-if="configoption.configtype === 'Sorten'"
          :option="configoption"
      />


      <OptionDropdown
          v-if="configoption.configtype === 'Dropdown'"
          :key="configoption.id"
          :option="configoption"
          @change="$emit('change', [configoption.id, $event])"
          :baseWidth="baseWidth"
          :doubleWidthAllowed="doubleWidthAllowed"
      />

      <OptionReadonly
          v-if="configoption.configtype === 'Readonly'"
          :key="configoption.id"
          :option="configoption"
          :baseWidth="baseWidth"
          :doubleWidthAllowed="doubleWidthAllowed"
      />

      <OptionQuantity
          v-if="configoption.configtype === 'Quantity'"
          :key="configoption.id"
          :option="configoption"
          :baseWidth="baseWidth"
      />

      <OptionAuflage
          v-if="configoption.configtype === 'Auflage'"
          :key="configoption.id"
          :option="configoption"
      />

      <OptionProduction
          v-if="configoption.configtype === CONFIGOPTION_TYPE_PRODUCTION"
          :key="configoption.id"
          :option="configoption"
      />

      <OptionFreeFormat
          v-if="configoption.configtype === CONFIGOPTION_TYPE_FREIFORMAT"
          :key="configoption.id"
          :option="configoption"
      />

      <OptionLieferart
          v-if="configoption.configtype === CONFIGOPTION_TYPE_LIEFERART && !configuratorService.hasConfigoptionType(CONFIGOPTION_TYPE_PRODUCTION)"
          :key="configoption.id"
          :option="configoption"
      />

      <OptionVorlagenproduktdesign
          v-if="configoption.configtype === CONFIGOPTION_TYPE_VORLAGENPRODUKTDESIGN"
          :key="configoption.id"
          :option="configoption"
      />


      <OptionPrintfileUpload
          v-if="configoption.configtype === 'Druckdatei Upload'"
          v-show="configoption.customValues.showUploadFile"
          :key="configoption.id"
          :option="configoption"
          :fileuploadid="configoption.id"
      />

      <PrintQUpload
          v-if="configoption.configtype === printqService.TYPE"
          :key="configoption.id"
      ></PrintQUpload>

    </template>
  </div>
</template>

<script>
import OptionDropdown from "components/OptionDropdown.vue";
import OptionReadonly from "./OptionReadonly";
import OptionQuantity from "./OptionQuantity";
import OptionAuflage from "./OptionAuflage";
import OptionProduction, {CONFIGOPTION_TYPE as CONFIGOPTION_TYPE_PRODUCTION} from "./OptionProduction";
import OptionLieferart, {CONFIGOPTION_TYPE as CONFIGOPTION_TYPE_LIEFERART} from "./OptionLieferart";
import PrintQUpload from "./PrintQUpload";
import OptionVorlagenproduktdesign, {
  CONFIGOPTION_TYPE as CONFIGOPTION_TYPE_VORLAGENPRODUKTDESIGN
} from "./OptionVorlagenproduktdesign";
import OptionPrintfileUpload from "./OptionPrintfileUpload";
import OptionFreeFormat, {CONFIGOPTION_TYPE as CONFIGOPTION_TYPE_FREIFORMAT} from "./OptionFreeFormat.vue";
import SortenInput from "./SortenInput.vue";

export default {
  name: "ConfigOptions",
  props: ['group', 'baseWidth', 'doubleWidthAllowed'],
  inject: ['configuratorService', 'printqService'],
  components: {
    SortenInput,
    OptionFreeFormat,
    OptionAuflage,
    OptionReadonly,
    OptionDropdown,
    OptionQuantity,
    OptionProduction,
    OptionLieferart,
    OptionVorlagenproduktdesign,
    OptionPrintfileUpload,
    PrintQUpload
  },
  data() {
    return {
      CONFIGOPTION_TYPE_LIEFERART: CONFIGOPTION_TYPE_LIEFERART,
      CONFIGOPTION_TYPE_PRODUCTION: CONFIGOPTION_TYPE_PRODUCTION,
      CONFIGOPTION_TYPE_VORLAGENPRODUKTDESIGN: CONFIGOPTION_TYPE_VORLAGENPRODUKTDESIGN,
      CONFIGOPTION_TYPE_FREIFORMAT: CONFIGOPTION_TYPE_FREIFORMAT,

    }
  }
}
</script>

<style scoped>
.dropflex {
  width: 100%
}
</style>